import React from "react";

export const Spark = ({ size = 18, color = "#B58B42", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="-20 -20 40 40"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M 0 -16 L 2 -2 L 16 0 L 2 2 L 0 16 L -2 2 L -16 0 L -2 -2 Z"
      fill={color}
    />
    <line x1="-18" y1="0" x2="-13" y2="0" stroke={color} strokeWidth="1" />
    <line x1="13" y1="0" x2="18" y2="0" stroke={color} strokeWidth="1" />
    <line x1="0" y1="-18" x2="0" y2="-13" stroke={color} strokeWidth="1" />
    <line x1="0" y1="13" x2="0" y2="18" stroke={color} strokeWidth="1" />
  </svg>
);

export default Spark;
